import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Calendar from '../../Calendar/Calendar';

class BasicDetailsCalendar extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.close = this.close.bind(this);
  }

  handleChange({ selectedDate }) {
    const { onChange } = this.props;

    onChange(selectedDate);
  }

  openTooltip() {}

  close() {}

  render() {
    return (
      <div className={this.props.containerClassName}>
        <Calendar
          onChange={this.handleChange}
          close={this.close}
          getDayStyle={this.props.getDayStyle}
          disablePast
        />
      </div>
    );
  }
}

BasicDetailsCalendar.propTypes = {
  onChange: PropTypes.func,
  getDayStyle: PropTypes.func.isRequired,
  containerClassName: PropTypes.string,
};

export default BasicDetailsCalendar;



// WEBPACK FOOTER //
// ./src/components/BasicDatails/BasicCalendar/BasicDetailsCalendar.js